import { render } from "./Saisie.vue?vue&type=template&id=52406bce&scoped=true"
import script from "./Saisie.vue?vue&type=script&lang=js"
export * from "./Saisie.vue?vue&type=script&lang=js"

import "./Saisie.vue?vue&type=style&index=0&id=52406bce&lang=scss&scoped=true"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52406bce"]])

export default __exports__